// CHID-2  Mahesh   17/01/2020    standByMD-1970: NLPSymptom Selector Implementation
import { withState, Component, Link } from "@mna/react";
import IconX from "assets/icons/x.svg";
import SymptomSearch from "./SymptomSearch";
import { classnames as cx } from '@mna/react'
import { Interpolate, Trans } from 'react-i18next'
import i18n from './../../../i18n'
import LoadingScreen from '../../../features/LoadingScreen'
import { checkAndGetLocalStorageValue, gtag } from "../../../features/utils";
import { vendorListCheckAndRedirect } from "../quick-telemedicine-screen";
import { careOptions, commonConstant } from "../../../server/triage/constants";
import i18next from "../../../../src/i18n";
const redirectTo = (history, page) => {
  history.push(page);
};

const Page = ({
  state,
  setState,
  actions,
  history,
  previousStepName,
  nextStepName,
}) => {
  const { triageRequest } = state
  const { presentRelatedSymptomSelected } = triageRequest
  const { absentRelatedSymptomSelected } = triageRequest
  const recommendedCareOptions = () => {
    actions.generateRecommendedCareOptions();
    return state.triageResponse.recommendedCareOptions;
  }
  if (state.isTravelAid2) {
    state.triageRequest.activeMenu = "related-symptoms";
  } else {
    state.triageRequest.activeMenu = "symptoms";
  }
  return state.isTravelAid2 ? (
    <div className="related-content">
      <div className="article-width">
        <LoadingScreen isLoading={state.isLoading_RelativeSymptom}>
          <div
            className="flex-grow selected-symptom-list"
            style={{ overflowY: "auto" }}
          >
            <h1 className="text-left standby-page-header-title mt-2 mb-3 w-form-label-justify">
              <Trans i18nKey="findcareoption.relatedsymptoms.related_title">
                Do you have any of the following symptoms?
              </Trans>
            </h1>
          </div>
          <div className="article-width">
            <div>
              <ul className="SelectedSymptoms standby-symptom-list">
                {state.RelatedSymptomInfo.map((symptom, index) => {
                  const isSymptomAdded = presentRelatedSymptomSelected.includes(
                    symptom.description
                  );
                  const isAbsentRelatedSymptomAdded =
                    absentRelatedSymptomSelected.includes(symptom.description);
                  const questionobj = symptom.description;
                  return (
                    <li key={`li-${index}`}>
                      <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
                        <div id={`btn-${index}`} className="standby-w-question">
                          <label className="standby-col standby-col-shrink ">
                            {questionobj}
                          </label>
                        </div>
                        <div className="standby-col standby-form-inline-fields">
                          <button
                            type="button"
                            id={`btnadd${index}`}
                            className={cx(
                              "button standby-symptom-button",
                              isSymptomAdded
                                ? state.isTravelAid2
                                ? "standby_Relatedsymptom_presentadd_travelAid2" 
                                : "standby_Relatedsymptom_presentadd"
                                : "standby_Relatedsymptom_presentremoved"
                            )}
                            onClick={() => {
                              if (isSymptomAdded) {
                                actions.presentRelatedSymptomRemoved({
                                  symptom,
                                });
                                actions.setTriageRequest({
                                  presentRelatedSymptomSelected:
                                    presentRelatedSymptomSelected.filter(
                                      (description) =>
                                        description !== symptom.description,
                                    ),
                                });
                                return;
                              }
                              if (
                                absentRelatedSymptomSelected.includes(
                                  symptom.description
                                )
                              ) {
                                actions.absentRelatedSymptomRemove({ symptom });
                                actions.setTriageRequest({
                                  absentRelatedSymptomSelected:
                                    absentRelatedSymptomSelected.filter(
                                      (description) =>
                                        description !== symptom.description
                                    ),
                                });
                              }
                              actions.presentRelatedSymptomAdd({ symptom });
                              actions.setTriageRequest({
                                presentRelatedSymptomSelected: [
                                  ...(presentRelatedSymptomSelected || []),
                                  symptom.description,
                                ],
                              });
                            }}
                            aria-label={questionobj + " " + i18next.t("findcareoption.Yes")} 
                          >
                            <div className="icon-add-symptom">
                              <Trans i18nKey="findcareoption.Yes">Yes</Trans>
                            </div>
                          </button>
                          <button
                            type="button"
                            id={`btnremove${index}`}
                            className={cx(
                              "button standby-symptom-button",
                              isAbsentRelatedSymptomAdded
                                ? state.isTravelAid2 
                                ? "standby-symptom-button-absentadd-travelAid2" 
                                : "standby-symptom-button-absentadd"
                                : "standby-symptom-button-absentremoved"
                            )}
                            onClick={() => {
                              if (isAbsentRelatedSymptomAdded) {
                                actions.absentRelatedSymptomRemove({ symptom });
                                actions.setTriageRequest({
                                  absentRelatedSymptomSelected:
                                    absentRelatedSymptomSelected.filter(
                                      (description) =>
                                        description !== symptom.description
                                    ),
                                });
                                return;
                              }
                              if (
                                presentRelatedSymptomSelected.includes(
                                  symptom.description
                                )
                              ) {
                                actions.presentRelatedSymptomRemoved({
                                  symptom,
                                });
                                actions.setTriageRequest({
                                  presentRelatedSymptomSelected:
                                    presentRelatedSymptomSelected.filter(
                                      (description) =>
                                        description !== symptom.description
                                    ),
                                });
                              }
                              actions.absentRelatedSymptomAdd({ symptom });
                              actions.setTriageRequest({
                                absentRelatedSymptomSelected: [
                                  ...(absentRelatedSymptomSelected || []),
                                  symptom.description,
                                ],
                              });
                            }}
                            aria-label={questionobj + " " + i18next.t("findcareoption.No")} 
                          >
                            <div className="icon-add-symptom">
                              <Trans i18nKey="findcareoption.No">No</Trans>
                            </div>
                          </button>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="mt-2  line-length">
              <button
                type="button"
                className={cx(
                  "button standby-button standby-button-gradient standby-button-full-width ",
                  state.triageRequest.absentRelatedSymptomSelected.length + state.triageRequest.presentRelatedSymptomSelected.length !== 6
                    ? "standby-button-disabled"
                    : "standby-button-gradient-green"
                )}
                disabled={state.triageRequest.absentRelatedSymptomSelected.length + state.triageRequest.presentRelatedSymptomSelected.length !== 6}
                onClick={async () => {
                  setState({
                    isLoading_RelativeSymptom: true,
                    isLoading: false,
                  });
                  gtag(
                    "set",
                    "content_group",
                    checkAndGetLocalStorageValue("orgid")
                  );

                  if (state.isTravelAid2) {
                    if (state.isLoading_RelativeSymptom) {
                      setState({ isLoading_RelativeSymptom: false });
                    }
                    if (state.triageRequest.presentRelatedSymptomSelected.length === 0 && state.triageResponse.vendorsList.length !== 0) {
                      var vendorArrayList = state.triageResponse.vendorsList;
                      var vendorsLength = 0;
                      if(vendorArrayList){
                        vendorsLength = vendorArrayList.length;
                      }
                      
                      if (vendorsLength === 0) {
                        history.push(`/find-care-options/telemedicine-info`);
                      } else if (vendorsLength >= 1) {
                        var vendorSupportedModal =
                          vendorArrayList[0].accessInformation.virtualAccessInformation
                            .webAccessReferences[0].supportedModalities;
                            state.triageRequest.supportedModalities = vendorSupportedModal.length
                        if (vendorSupportedModal.length >= 2) {
                          //both option
                          history.push(`/find-care-options/telemed-connectiontype`);
                        } else {
                          if (vendorSupportedModal[0] === "Video") {
                            //redirect to video prompt
                            state.triageResponse.selectedConnectionType="2"
                            history.push(`/find-care-options/telemed-videoprompt`);
                          } else {
                            //redirect to connection page
                            state.triageResponse.selectedConnectionType="1"
                            history.push(`/find-care-options/telemedicine-info`);
                          }
                        }
                      } else if (vendorsLength > 1) {
                        var allVendorsArray = [];
                        state.triageResponse.vendorsList.map((item) => {
                          var vendors = item.nameLocalization.localizations[0].value;
                          if (allVendorsArray.indexOf(vendors) === -1) {
                            allVendorsArray.push(vendors);
                          }
                        });
                        if (allVendorsArray.length >= 1) {
                          var vendorSupportedModalities =
                            vendorArrayList[0].accessInformation.virtualAccessInformation
                              .webAccessReferences[0].supportedModalities;
                         
                          if (vendorSupportedModalities.length >= 2) {
                            //both option
                            history.push(`/find-care-options/telemed-connectiontype`);
                          } else {
                            if (vendorSupportedModalities[0] === "Video") {
                              state.triageResponse.selectedConnectionType="2"
                              //redirect to video prompt
                              history.push(`/find-care-options/telemed-videoprompt`);
                            } else {
                              state.triageResponse.selectedConnectionType="1"
                              //redirect to connection page
                              history.push(`/find-care-options/telemedicine-info`);
                            }
                          }
                        } else {
                          history.push(`/find-care-options/telemedicine-info`);
                        }
                      }
                      await actions.submitEmergencyAnswers();
                      await actions.updateVendorContact();
                      state.triageRequest.selectedCareOptionName = careOptions.Telemedicine
                      localStorage.setItem("careoption", careOptions.Telemedicine);
                      //var response = await actions.FindMember();
                      // if (response && response.message === commonConstant.success)
                      // {
                      //   var result = response.response;
                      //   var response = await actions.AddOrUpdateMemberSearch({state, actions, setState, result});
                      //   localStorage.setItem("isSearchMemberAdded", true);
                      // }
                    }
                    else {
                      recommendedCareOptions();
                      await actions.submitEmergencyAnswers();
                      history.push("/find-care-options/care-options")
                    }
                  }
                  else {
                    await actions.submitRelatedSymptoms();
                    await actions.clearQuestionsState();
                    state.orderIdArray = [];
                    await actions.getQuestions(
                      { state, actions, setState, nextStepName, history },
                      (lang = i18n.language),
                      (isQuestionLog = false)
                    );
                  }
                }}
              >
                <Trans i18nKey="findcareoption.relatedsymptoms.Next">
                  Next
                </Trans>
              </button>
            </div>
          </div>
        </LoadingScreen>
      </div>
    </div>
  ) : (
    <div className="modal-content mt-0">
      <div className="article-width flex flex-column symptom-modal-content full-height mt-0 pt-1">
        <div className="flex-grow selected-symptom-list">
          <SymptomSearch {...{ state, setState, actions, history }} />
        </div>
      </div>
    </div>
  );
};
export default withState({
  didMount({ state, setState, actions, history }) {
    console.log('symptoms', "symptoms page");
    actions.resetQTState(state, setState);
    actions.clearTriageQuestions();
  },
})(Page);
